<template>
  <v-container fluid ma-0 pa-0>
      <v-row>
          <v-col cols="6" class="pa-0 d-flex align-center justify-center" style="background-color: #f1f4f6">
            <div style="width: 406px">
              <v-img src="https://east-e.co.jp/common/img/f-logo.svg" width="200px" eager style="margin: auto"></v-img>
              <h2 class="pt-4 pb-4" style="text-align:center;">ドローンレポートシステム</h2>
              <v-divider class="mb-10"></v-divider>
              <h3 class="text-center">パスワードリセット</h3>
              <v-form
                  ref="resetPassForm"
                  v-model="resetPassValid"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        label="新規パスワード*"
                        :type="showPassword ? 'text' : 'password'"
                        required
                        outlined
                        dense
                        :rules="passRules"
                        v-model="inputResetPass.new_password1"
                        hide-details="auto"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                        counter
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                        label="新規パスワード確認*"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        required
                        outlined
                        dense
                        :rules="passRules"
                        v-model="inputResetPass.new_password2"
                        hide-details="auto"
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showConfirmPassword = !showConfirmPassword"
                        counter
                        clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-btn
                  color="primary"
                  style="width:100%;"
                  @click="confirm_reset_pass_mail()"
              >
                リセット
              </v-btn>
            </div>
<!--            <v-card style="padding-top:100px;" width="500px">-->
<!--                <h3 class="text-decoration-underline font-italic pb-5" style="text-align:center;">DRONE REPORT SHARING</h3>-->
<!--                <h5 class="pl-2">※パスワードリセット</h5>-->
<!--                <v-card-text>-->
<!--                -->
<!--                -->
<!--                </v-card-text>-->
<!--                <v-card-actions>-->
<!--                <v-spacer></v-spacer>-->
<!--                -->
<!--                </v-card-actions>-->
<!--            </v-card>-->
          </v-col>
          <v-col cols="6" class="pa-0">
              <v-img src="../assets/images/cover.jpg" height="100vh" class="grey lighten-2"></v-img>
          </v-col>
      </v-row>
    
  </v-container>
</template>

<script>
import {store} from '@/store';
export default {
  name: "ResetPassword",
  
  data() {
      return {
        inputResetPass: {
            new_password1: null,
            new_password2: null,
            token: this.$route.params.token,
            uid: this.$route.params.uid,
        },
        resetPassValid: true,
        passRules: [
            v => !!v || '新規パスワードを入力してください。',
            v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入力してください。'
            // length 8, least 1 uppercase, least 1 lowercase,  least 1 number
            // フィールド値が有効なパスワードであることを確認します。大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードである必要があります。
        ],
        showPassword: false,
        showConfirmPassword: false
      }
    
  },

  methods: {
      confirm_reset_pass_mail() {
        if (this.$refs.resetPassForm.validate()) {
            this.axios.post("/api/dj-rest-auth/password/reset/confirm/"+this.$route.params.uid+ "/"+this.$route.params.token+"/", this.inputResetPass)
            .then(() => {
                store.showSuccessDialog("パスワードがリセットされました。");
                this.$router.push('/login');
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    if ('new_password2' in error.response.data) {
                        store.showErrorDialog(error.response.data.new_password2[0]);
                    }
                } else {
                    store.showErrorDialog("エラーが発生しました。再度試してください。");
                }
            });
        }
      }
    
  },

}
</script>

<style scoped>

</style>
